import { render, staticRenderFns } from "./ModuleNavLink.vue?vue&type=template&id=44095d5e&"
import script from "./ModuleNavLink.vue?vue&type=script&lang=js&"
export * from "./ModuleNavLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports